export class AlignVertical {
    constructor() {
        const alignModule: NodeListOf<HTMLElement> = document.querySelectorAll("[data-align-vertical-source]") as NodeListOf<HTMLElement;
        const alignModulePair: NodeListOf<HTMLElement> = document.querySelectorAll("[data-align-vertical-target]") as NodeListOf<HTMLElement;

        if (alignModule && alignModule.length === alignModulePair.length) {
            this.Initialize();
        }
    }

    private Initialize() {
        const sources: NodeListOf<HTMLElement> = document.querySelectorAll("[data-align-vertical-source]") as NodeListOf<HTMLElement;
        const targets: NodeListOf<HTMLElement> = document.querySelectorAll("[data-align-vertical-target]") as NodeListOf<HTMLElement;     

        for (let i = 0; i < sources.length; i++)
        {
            const height: number = sources[i].clientHeight;
            targets[i].style.height = `${height}px`;
        }   
    }
}



// WEBPACK FOOTER //
// ./src/global/AlignVertical.ts